import AlertMessage from '@/app/components/AlertMessage'

type Props = {
  /**
   * Display name of the prescribed setting, e.g. "Save Money".
   */
  settingDisplayName: string
  /**
   * Direction the program requires the setting to be in. Defaults to `'on'`
   * to preserve the original copy for callers that haven't been updated.
   */
  requiredDirection?: 'on' | 'off'
}

/**
 * Renders the "<setting> setting is required to be turned <on|off> to be
 * eligible for this program" copy as an info alert.
 *
 * Some programs prescribe a setting to be off — e.g. PNM requires
 * "Save the Planet" to be off and "Save Money" to be on — so the copy has
 * to mirror the prescribed direction, not assume on.
 */
export default function ProgramPrescribedAlert({
  settingDisplayName,
  requiredDirection = 'on',
}: Props) {
  return (
    <AlertMessage variant="info">
      {settingDisplayName} setting is required to be turned {requiredDirection}{' '}
      to be eligible for this program
    </AlertMessage>
  )
}
